export const setModalSubordinate = async ({ commit }, val) => {
  commit('setModalSubordinate', val)
}

export const setSideDev = async ({ commit }, val) => {
  commit('setSideDev', val)
}

export const setSideSettingProspek = async ({ commit }, val) => {
  commit('setSideSettingProspek', val)
}

export const setSideSettingActivity = async ({ commit }, val) => {
  commit('setSideSettingActivity', val)
}

export const setSideSettingCustomer = async ({ commit }, val) => {
  commit('setSideSettingCustomer', val)
}

export const setSideSettingEmployee = async ({ commit }, val) => {
  commit('setSideSettingEmployee', val)
}

export const setSidebar = async ({ commit }, val) => {
  commit('setSidebar', val)
}

export const setPrompt = async ({ commit }, val) => {
  commit('setPrompt', val)
}

export const setScreenWidth = async ({ commit }, val) => {
  commit('setScreenWidth', val)
}

export const setMenuSide = async ({ commit }, val) => {
  commit('setMenuSide', val)
}

export const setNotif = async ({ commit }, val) => {
  commit('setNotif', val)
}
